var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5041 19.1678C22.0449 19.1678 23.3392 17.9352 23.3392 16.3943C23.3392 14.8535 22.0449 13.6208 20.5041 13.6208C18.9632 13.6208 17.6689 14.8535 17.6689 16.3943C17.6689 17.9352 18.9016 19.1678 20.5041 19.1678Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9461 29.399H34.4946V39.815H32.0909L31.228 29.2141H28.1464L27.4684 39.815H24.8182V30.8782H23.7704L24.3251 39.9999H21.3667L20.3189 32.0492L19.2095 39.9999H16.5593L16.9291 30.8782H15.6964L15.5115 24.8998V23.9753H14.3405L15.265 39.815H11.1972L9.71802 28.721L8.11556 39.815H4.41756L5.0339 23.9136H3.24653L3 15.7781V13.0046C3 10.8474 4.41756 9.06003 6.38983 8.8135L7.12943 8.69024H13.1079L13.9091 8.8135C15.8813 9.12167 17.2989 10.909 17.2989 13.0662V20.0308C17.4838 19.9691 17.6071 19.9075 17.792 19.9075L18.3467 19.8459H22.661H22.8459C23.2157 17.2573 23.5855 14.7303 23.832 13.2511C24.2018 10.7241 25.1263 8.6286 28.3313 8.6286H30.735C34.0015 8.56697 34.8644 10.5392 35.2342 13.2511C35.7889 16.0246 37.9461 29.399 37.9461 29.399Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5636 0C27.468 0 25.6807 1.78736 25.6807 3.94453C25.6807 6.10169 27.4064 7.88906 29.5636 7.88906C31.7207 7.88906 33.4465 6.10169 33.4465 3.94453C33.4465 1.78736 31.7207 0 29.5636 0Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2725 7.64252C12.4297 7.64252 14.1554 5.91679 14.1554 3.82126C14.1554 1.72573 12.4297 0 10.2725 0C8.11538 0 6.38965 1.72573 6.38965 3.82126C6.38965 5.91679 8.11538 7.64252 10.2725 7.64252Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.d3055fa72880686959f30bc533025a05.svg";
export { ForwardRef as ReactComponent };